import Comm from '../services/comm';

export default{
    namespaced: true,
    state: {
        listLoading: false,
        listError: null,
        saveLoading: false,
        saveError: null,
    },
    actions: {
        getEmailNotificationList(context, data){
            context.state.listError = null;
            context.state.loading = true;
            Comm.getData('emailmethods.php').then(
                res => {
                    data.result(res);
                    context.state.listLoading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.listLoading = false;
                }
            )
        },
        saveEmailNotification(context, data){
            context.state.saveError = null;
            context.state.saveLoading = true;
            Comm.putData('emailmethods.php', {data: data.data}).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.saveError = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                        data.reject(res);
                    }
                    context.state.saveLoading = false;
                },
                rej => {
                    context.saveError = 'Hiba történt mentés közben, kérem forduljon a rendszergazdához!';
                    data.reject(rej);
                    context.state.saveLoading = false;
                }
            )
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/emailNotificationStore.js